<div class="quote-product-date" [class.quote-product-date--array]="isArray">
  <div *ngFor="let dateRange of productSelectedWeeks">
    <span *ngIf="!isArray">&nbsp;(</span>
    <span>{{ dateRange.startDate | lxDate : dateFormat }}</span
    ><span *ngIf="dateRange.endDate"> - {{ dateRange.endDate | lxDate : dateFormat }}</span>
    <span *ngIf="!isArray">)</span>
  </div>
</div>
